import {useState, useEffect} from 'react';
import {
    AppBar,
    Toolbar,
    Box,
    Typography,
    Button,
    Card,
    TextField,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import { VerticalSpace } from '../components';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ColorsArray = ["#EF9A9A", "#F48FB1", "#CE93D8", "#B39DDB", "#9FA8DA", "#90CAF9", "#81D4FA", "#80DEEA"]

const KidCard = ({ id, name, color, testDoc }) => {
    const navigate = useNavigate()

    const onCardClick = () => {
        if(!testDoc || testDoc === 'null' || testDoc === 'undefined')
            return null;
        
        navigate(`/${testDoc}?kid=${id}`)
    }

    return (
        <Paper sx={{
            background: color,
            display: 'flex',
            alignItems: 'flex-end',
            minWidth: "200px",
            height: "100px",
            padding: "20px",
            margin: "10px",
            borderRadius: "10px",
            overflow: 'hidden',
            cursor: 'pointer'
        }} 
        onClick = {onCardClick}
        >
            <Typography
                variant='h5'
                sx={{
                    textAlign: 'left',
                    fontWeight: 700
                }}
            >
                {name}
            </Typography>
        </Paper>
    )
}

const Leaderboard = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [accountId, setAccountId] = useState(localStorage.getItem('brainsprays-accountId'))
    const [kids, setKids] = useState([])
    const [leaderBoard, setLeaderboard] = useState([])

    const getKids = async () => {
        try {
            if(accountId) {
                const {data} = await axios.get(`https://dapp-backend.triadkube.com/auth/list-kids/${ accountId || searchParams.get('id') }`)
                setKids(data.result)
            }
        } catch (error) {
            toast.error("Something went wrong")
        }
    }

    const getLeaderboard = async () => {
        try {
            const {data} = await axios.get(`https://dapp-backend.triadkube.com/auth/leaderboard`)
            // console.log("LEADERBOARD", data.result)
            setLeaderboard(data.result)
        } catch (error) {
            toast.error("Something went wrong")
        }
    }

    useEffect(() => {
        getKids()
        getLeaderboard()
    }, [])

    return (
        <Box
            sx={{
                flex: '1',
                display: 'block',
                height: '100vh',
            }}
        >
            <AppBar position="fixed">
                <Toolbar>
                <Typography
                    variant='h5'
                    sx={{
                        textAlign: 'left',
                        fontWeight: 700
                    }}
                >
                    Leaderboard
                </Typography>
                </Toolbar>
            </AppBar>
            <VerticalSpace count={10} />
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                    <TableRow>
                        <TableCell>Rank</TableCell>
                        <TableCell >Name</TableCell>
                        <TableCell >Parent</TableCell>
                        <TableCell >Total Points</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {
                        leaderBoard.map((kid, index) => {
                            const isKidBelongToParent = kids.some(selfKid => selfKid._id === kid._id);
                            return (
                                <TableRow
                                key={kid._id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: isKidBelongToParent?'#8BC34A':'#FFFFFF' }}
                                >
                                <TableCell sx={{fontWeight: isKidBelongToParent?700:400, color: isKidBelongToParent?'#FFFFFF':'rgba(0,0,0,0.87)', fontSize: isKidBelongToParent?'1rem':'0.875rem'}} component="th" scope="row">
                                    #{index+1}
                                </TableCell>
                                <TableCell sx={{fontWeight: isKidBelongToParent?700:400, color: isKidBelongToParent?'#FFFFFF':'rgba(0,0,0,0.87)', fontSize: isKidBelongToParent?'1rem':'0.875rem'}} align="left">{kid?.name}</TableCell>
                                <TableCell sx={{fontWeight: isKidBelongToParent?700:400, color: isKidBelongToParent?'#FFFFFF':'rgba(0,0,0,0.87)', fontSize: isKidBelongToParent?'1rem':'0.875rem'}} align="left">{kid?.parent.displayName}</TableCell>
                                <TableCell sx={{fontWeight: isKidBelongToParent?700:400, color: isKidBelongToParent?'#FFFFFF':'rgba(0,0,0,0.87)', fontSize: isKidBelongToParent?'1rem':'0.875rem'}} align="left">{kid?.totalPoints}</TableCell>
                                </TableRow>
                            )
                        })
                    }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default Leaderboard;